import { configureStore } from "@reduxjs/toolkit";
import { setupListeners } from "@reduxjs/toolkit/query";
import { thunk } from "redux-thunk";
import rootReducer from "./reducers";
import { apiSlice } from "./api/apiSlice";

const store = configureStore({
  reducer: rootReducer,
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware().concat(thunk, apiSlice.middleware),
  devTools: process.env.NODE_ENV !== "production",
});

// Wires the browser online/focus events into RTK Query so the
// `refetchOnReconnect` option in the api slice actually fires.
setupListeners(store.dispatch);

export type RootState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch;

export default store;
